import React, { useEffect, useState } from "react";
import { Image, ImageStyle, StyleProp } from "react-native";
import { menuImageUri } from "../lib/utils";

/**
 * 메뉴 이미지 썸네일 렌더러 — 400px `_t` 썸네일을 먼저 로드하고, 없으면(S3 404) 원본(full)으로 자동 폴백.
 * 서버 배포/썸네일 백필 완료 여부와 무관하게 항상 이미지를 표시한다(구서버 매장·백필 전 이미지 안전).
 *
 * 리스트/카드/작은 썸네일 등 비-히어로 화면에서 사용. 상세 히어로는 원본을 그대로 쓴다(menuUri).
 */
export default function ThumbImage({
  shopid,
  menuid,
  imageVer,
  style,
  resizeMode,
}: {
  shopid: string;
  menuid: number;
  imageVer: number;
  style?: StyleProp<ImageStyle>;
  resizeMode?: "cover" | "contain" | "stretch" | "center" | "repeat";
}) {
  const [failed, setFailed] = useState(false);

  // FlatList 재활용 등으로 같은 인스턴스가 다른 항목을 렌더하면 폴백 상태를 초기화해 다시 썸네일부터 시도.
  useEffect(() => setFailed(false), [shopid, menuid, imageVer]);

  const source = menuImageUri(shopid, menuid, imageVer, !failed);   // 썸네일 우선, 실패 시 원본

  return (
    <Image
      source={source}
      style={style}
      resizeMode={resizeMode}
      onError={() => setFailed(true)}
    />
  );
}
